import defaultColorPalette from '../../components/userDocuments/editDocument/editResume/EditSpace/EditorPane/Pad/Preview/colorPalette';
import { universityRestriction } from '../universityRestrictions';

interface CustomTemplateColorPaletteParams {
  universityPlan: {
    code?: string;
  };
}

const getCustomTemplateColorPalette = ({
  universityPlan,
}: CustomTemplateColorPaletteParams) => {
  const activeColorSet =
    universityPlan?.code &&
    universityRestriction[universityPlan?.code]?.templatesPolicy
      ?.activeColorSet;

  return {
    ...defaultColorPalette,
    active: activeColorSet || defaultColorPalette.active,
  };
};
export default getCustomTemplateColorPalette;
